import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { StatusCard } from '@node-space/storybook-components/dist/StatusCard'
import { Box, Button, Text } from '@node-space/ui-components'

interface EmptyStateProps {
  onAddNewWebHook: () => void
}

export const EmptyState = ({ onAddNewWebHook }: EmptyStateProps) => {
  const { t } = useTranslation()

  return (
    <StatusCard headline={t('integrations.noWebhooksMessage')}>
      <Box width="full" centerChildren paddingB={16} className="sm:flex">
        <Text>
          {t('integrations.hooksDescription')}
          <Link
            to={
              'https://help.bvnk.com/hc/en-us/articles/22943700946450-Webhook-Configuration-in-the-BVNK-Portal'
            }
            className="ml-1 text-primary-500"
            target="_blank"
          >
            {t('learnMore')}
          </Link>
        </Text>
      </Box>
      <Box>
        <Button name={t('integrations.addHook')} onClick={onAddNewWebHook}>
          {t('integrations.addHook')}
        </Button>
      </Box>
    </StatusCard>
  )
}
